module.exports = __webpack_public_path__ + "img/744.e033773a.jpg";